import { cn } from "@/lib/utils";

export function Caption({
	children,
	className,
}: {
	children: React.ReactNode;
	className?: string;
}) {
	return (
		<figcaption
			className={cn(
				"font-body italic text-sm text-muted-foreground mt-2",
				className
			)}
		>
			{children}
		</figcaption>
	);
}
